export const errImage = (item) => {
    const man = 'userPhoto/to+me.png';
    const woman = 'userPhoto/you+die.png';
    if (parseInt(item.sex) === 1) {
        return man;
    } else {
        return woman;
    }
};
